$('.product-detail__dropdown-anchor').on('click', function(e) {
    /* Group selector - when clicked, select all checkboxes from a particular group */
    $('.product-detail__dropdown-menu__item--bold input').on('click', function() {
        if($(this).prop('checked') === true){
            $(this).parent().parent().siblings().find('.custom-checkbox__input').prop('checked', true);
        } else {
            $(this).parent().parent().siblings().find('.custom-checkbox__input').prop('checked', false);
        }
    });
});